import {
  React,
  useContext,
  useEffect,
  useState,
} from 'react';

import {
  Button,
  Col,
  Container,
  Row,
} from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { BsCloudDownload } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

import {
  getDownloadLink,
  getMessages,
  requestApproveApplication,
  sendEmailLinkRequest,
  saveSession
} from '../libs/api.js';
import {
  BrandingContext,
  LayoutContext,
  SessionContext,
} from '../libs/contexts.js';
import { scrollUp } from '../libs/ui.js';
import { EmailValidationBox } from './email-code.jsx';
import {
  PolicyDelayed,
  PolicyFailed,
  PolicyOngoing,
} from './policy-progress.jsx';

export const Policy = () => {

    const { layout, setLayout } = useContext(LayoutContext);
    const { branding } = useContext(BrandingContext);
    let navigate = useNavigate();
    const { session, setSession } = useContext(SessionContext);
    const [timer, setTimer] = useState(false);
    const [approved, setApproved] = useState(false);
    const [waiting, setWaiting] = useState(false);
    const [verified, setVerified] = useState(false);
    const [pdfLink, setPdfLink] = useState(false);
    const [failed, setFailed] = useState(false);
    const [emailOk, setEmailOk] = useState(false);
    const [sentEmail, setSentEmail] = useState(false);
    const [longRunning, setLongRunning] = useState(false);


    useEffect(() => {

        scrollUp();
        setLayout({
            screenReady: true,
            currentScreen: 'policy',
            currentSection: 'payment',
        });

    }, []);

    useEffect(() => {
        if (session.approved) {
            if ("yes" === session.approved) {
                saveSession({
                    quote: session, token: session.token
                });
            } else {
                let newSessionEntry = {
                    "outcome": "rejected",
                    "next": "thankyou"
                };
                setSession(newSessionEntry);
                
                let newVerified = 'fail';
                setVerified(newVerified);
                clearInterval(timer);
                setTimer(false);
                navigate(`/thankyou`);
            }

        }
    }, [session.approved]);



    useEffect(() => {
        if (waiting) {

            if (!session.applied) {
                let newSessionEntry = { applied: "yes" };
                setSession(newSessionEntry);
            }
        }
    }, [waiting]);

    useEffect(() => {
        if (emailOk) {
            requestApproveApplication(
                {
                    token: session.token,
                    next: (data) => {
                        setInterval(() => {
                            getMessages({
                                token: session.token,
                                next: (data) => {
                                    console.log("Got message", data);
                                    if (data.notifications) {
                                        for (let notification of data.notifications) {
                                            if (undefined !== notification.bigfile) {
                                                if ('yes' === notification.bigfile) {
                                                    console.log("Got a pdf to download", notification);
                                                    setSession({ approved: "yes", applied: "yes", download: "ready" });
                                                }
                                            } else if (undefined !== notification.failedmib) {
                                                if ('yes' === notification.failedmib) {
                                                    console.log("Got notification of MIB failure, redirecting");
                                                    setSession({ approved: "no"});
                                                }
                                            }
                                        }
                                    }

                                }
                            })
                        }, 3000)
                        setTimeout(() => {
                            setLongRunning(true);
                        }, 120000);
                    },
                }
            );
        }
    }, [emailOk, session.token])

    useEffect(() => {

        console.log("session: ", session);
        if (session.approved) {

            if ("yes" === session.approved) {

                setApproved("yes");
                if (session.applied) {

                    if ("yes" === session.applied) {

                        if ("ready" === session.download) {

                            getDownloadLink({
                                token: session.token,
                                next: (data) => {
                                    let newVerified = 'pass';
                                    setVerified(newVerified);
                                    let newPdfLink = data.url;
                                    setPdfLink(newPdfLink);
                                    clearInterval(timer);
                                    setTimer(false);
                                }
                            });
                            sendEmail();
                        } else {
                            //console.info("Download not ready");
                        }
                    }
                } else {
                    //console.info("Not applied yet");
                    // if (emailOk) {
                    //     requestApproveApplication((data) => {
                    //         setWaiting(Date.now());
                    //     });
                    // }
                }
            } else {
                //console.info("Not approved yet");
                setApproved("no");
            }

        }
    }, [session.approved, session.applied, session.download, session.token]);

    const sendEmail = (e) => {
        if (session.email_verified && session.email_verified === "yes" && !sentEmail) {
            setSentEmail(true);
            sendEmailLinkRequest({
                quote: session.quote,
                verbose: true,
                token: session.token,
                next: (data) => {
                    //nothing
                }
            });
            setSession({ sent_policy_email: "yes" });
        };   
    }

    return (
        <>
            <Container fluid>

                { (emailOk) ?
                    <>
                        { verified ?
                            <>
                                <Row>
                                    <Col>
                                        <h1 className="display-4 fw-bold lh-1 mb-3">Your insurance policy</h1>
                                    </Col>
                                </Row>
                                <Row className="mt-2">
                                    { 'pass' === verified ?
                                        <Col className="col-lg-12 text-center text-lg-start">
                                            <div className="mt-1">
                                                { pdfLink ?
                                                    <DownloadOptions pdfLink={ pdfLink } />
                                                    :

                                                    <p>Your application has been approved. We're preparing your documents...</p>


                                                }
                                            </div>
                                        </Col>
                                        :
                                        <Col className="col-lg-12 text-center text-lg-start">
                                            <PolicyDelayed />
                                        </Col>
                                    }

                                </Row>
                            </>
                            :
                            <>
                                { failed ?
                                    <Row className="mt-4">
                                        <Col>
                                            <PolicyFailed />
                                        </Col>
                                    </Row>
                                    :
                                    <>

                                        { longRunning ?
                                            <>
                                                <PolicyDelayed />
                                            </>
                                            :
                                            <>
                                                <Row className="mt-4">
                                                    <Col>
                                                        <PolicyOngoing />
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                    </>
                                }

                            </>
                        }
                    </>
                    :
                    <>
                        <Row>
                            <Col>
                                <EmailValidationBox setEmailOk={ setEmailOk } />
                            </Col>
                        </Row>
                    </>
                }

            </Container>

        </>
    )
}

const DownloadOptions = ({ pdfLink }) => {

    const { session } = useContext(SessionContext);
    const [ready, setReady] = useState(false);
    const [sentPolicyEmail, setSentPolicyEmail] = useState(false);

    useEffect(() => {

        setTimeout(() => {
            setReady(true);
        }, 5000);

    }, []);

    useEffect(() => {
        if (session.sent_policy_email) {
            if ("yes" === session.sent_policy_email) {
                setSentPolicyEmail(true);
            }
        }
    }, [session.sent_policy_email]);

    return (
        <Container fluid>
            <Row>
                <Col>
                    <p>
                        Your policy has been approved!
                    </p>
                    { !ready &&
                        <>
                            <Spinner animation="grow" role="status" />
                            <p>We're preparing a download link, just a moment. </p></>
                    }
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    { ready &&
                        <Button target="_blank" rel="noopener noreferrer" href={ pdfLink } variant="outline-primary" ><BsCloudDownload /> Download</Button>
                    }
                    { ready && sentPolicyEmail &&
                        <>
                            <hr />
                            <p>A copy of your insurance policy has been sent to {session.email}.</p>
                        </>
                    }

                </Col>
            </Row>
        </Container>

    )

}